import React from "react";
import IncompleteRequestsDashboard from "../components/requests/IncompleteRequestsDashboard";

export default function IncompleteOperationalRequestsPage() {
  return <IncompleteRequestsDashboard scope="operational" />;
}
